import { styled } from 'styled-components'

export const ContactContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid var(--gray200);
  border-radius: 0.5rem;
  gap: 0.5rem;
  padding: 1rem;
  margin-bottom: 1rem;
`

export const ConstactsContainer = styled.div`
  display: flex;
  flex-direction: column;
`
